var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-user-balance"},[_c('inline-svg',{staticClass:"dapp-logo__image",class:'dapp-user-balance__icon',attrs:{"src":_vm.getImageUrl('icons/coins.svg'),"width":16}}),_vm._v(" "+_vm._s(_vm.userBalance)+" "+_vm._s(_vm.$t("common.currency_name"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }